<template>
  <notification-card
    :title="title"
    :variation="cardVariant"
    :icon-class="iconClass"
    :icon="icon"
    :iso-timestamp="n['@timestamp']">
    <template #menu>
      <NotificationMenu :n="n" :variant="menuVariant" />
    </template>
    <template v-if="attCount > 0" #attachments_menu>
      <AttachmentsMenu :n="n" />
    </template>
    <template v-if="attCount > 0" #attachments>
      <AttachmentsViewer :n="n" />
    </template>
    <b-tag v-if="n.metaData.ProcessName" class="mb-2" size="is-medium" :type="tagClass">{{ n.metaData.ProcessName }}</b-tag>
    <p>{{ content }}</p>
  </notification-card>
</template>

<script>
import { styleOptionByMessage } from './desktop-fallback'
import attachments from '@/services/attachments'
import { pascalToHuman } from '@/services/text/humanify'
export default {
  props: {
    n: Object
  },
  computed: {
    meta () { return this.n.metaData },
    content () {
      const res = styleOptionByMessage(this.n, 'content', 'content')
      if (typeof(res) === 'object' && res.text) return res.text
      return this.meta[res] // property name
    },
    title () {
      const res = styleOptionByMessage(this.n, 'title', { text: pascalToHuman(this.n.message) })
      if (typeof(res) === 'object' && res.text) return res.text
      return this.meta[res]
    },
    iconClass () { return styleOptionByMessage(this.n, 'iconClass') },
    icon () { return styleOptionByMessage(this.n, 'icon') },
    menuVariant () { return styleOptionByMessage(this.n, 'menuVariant') },
    tagClass () { return styleOptionByMessage(this.n, 'tagClass', 'is-info') },
    cardVariant () { return styleOptionByMessage(this.n, 'cardVariant') },
    attCount () { return attachments.parse(this.n).all.length },
  }
}
</script>